import { PUT_LIST_ITEMS_START } from '../../types';

export const put_list_items = (payload) => ({
  type: PUT_LIST_ITEMS_START,
  payload,
});
